/**
 * @description Sortable table head component
 * @param {SortableColumn} column - The column to sort
 * @param {string} label - The label of the column
 * @param {React.ReactNode} sortIcon - The icon to display when the column is sorted
 * @param {function} onSort - The function to call when the column is sorted
 * @param {boolean} isActive - Whether the column is active
 * @returns {React.ReactNode} - The sortable table head component
 */

import { TableHeadCell } from "flowbite-react";
import type { SortableColumn } from "@/features/vouchers";

type SortableTableHeadProps = {
  column: SortableColumn
  label: string
  sortIcon: React.ReactNode
  onSort: (column: SortableColumn) => void
  isActive?: boolean
};

export const SortableTableHead = ({
  column, label, sortIcon, onSort, isActive = false,
}: SortableTableHeadProps) => {
  return (
    <TableHeadCell
      className={`cursor-pointer bg-gray-50 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors ${
        isActive ? "border-b-2 border-primary" : ""
      }`}
      onClick={() => onSort(column)}
    >
      <div className={`flex items-center gap-2 transition-colors duration-100 ${
        isActive
          ? "text-primary dark:text-primary font-semibold"
          : "text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
      }`}
      >
        <span className="uppercase">{label}</span>
        <span className="text-sm">{sortIcon}</span>
      </div>
    </TableHeadCell>
  );
};
